import Performances from './Performances.vue'

export default Performances
